import React, { useMemo } from 'react';
import dynamic from 'next/dynamic';
import { useTranslation } from 'react-i18next';
import { NextSeo } from 'next-seo';
import { Layout } from '../../components/Layout/Layout';
import { ItemCreationSkeleton } from '../../components/Placeholders/ItemCreationFormPlaceholder';
import { ItemCreationForm } from '../../components/ItemCreationForm';

const NewItemContent = () => {
  const { t } = useTranslation();

  const returnURL = useMemo(() => {
    if (typeof window !== 'undefined') {
      return document.referrer || '';
    }
    return '';
  }, []);

  return (
    <>
      <NextSeo title={t('pages.new_item.title')} noindex nofollow />
      <Layout isShowFooter={false} isBottomNavigation={false}>
        <ItemCreationForm returnURL={returnURL} />
      </Layout>
    </>
  );
};

const NewItemPageCleanCSR = dynamic(() => Promise.resolve(NewItemContent), {
  ssr: false,
  loading: () => <ItemCreationSkeleton />
});

export default NewItemPageCleanCSR;
